module.exports = require("!!vue-loader!../../../node_modules/vue-markdown-loader/lib/markdown-compiler.js?raw!./its-not-easy.md");


//////////////////
// WEBPACK FOOTER
// ./src/assets/posts/its-not-easy.md
// module id = 26
// module chunks = 5